import React, {Component} from 'react'

export default class Computer extends Component {
  render() {
    return (
      <div className=" py-20 th-home--mobiletop-val   bg-primary" style={{marginTop: ''}}>
        <div className="container grid-xl pt-8 text-center" style={{marginBottom: '1rem', marginTop: '2rem'}} id="#activity">
          <div className="container grid-xl text-center th-home--mobilevalstatement">
            <p className="h1 th-home--mobilefonth2 text-white th-font-av " style={{marginTop: '1rem'}}>
              Get to the signing table, <i>faster</i>.
            </p>
            <p
              className="container grid-lg h4 th-home--mobiletop th-home--mobilefonth4 th-home--padmob"
              style={{color: '#ffffff', marginTop: '1rem', marginBottom: '6rem', fontSize: '1.5em'}}>
              Listing Management software for efficient agents. <br />
              Reduce your busy work and keep everything in one place.
            </p>
            {/* <div className="text-right container grid-lg th-home--mobiletop th-home--padmob" style={{marginBottom: '3rem', color: '#50596c'}}>
              <span className="text-small">Read More &nbsp;</span>
              <i className="far fa-file-alt " style={{transform: 'rotate(20deg)'}} />
            </div> */}
          </div>
        </div>
      </div>
    )
  }
}
